export default __webpack_public_path__ + "static/media/033-exit-1.5c381f51.png";